import { render, staticRenderFns } from "./CameraPageShootCardAutoDriversLicenseDiagonal1.vue?vue&type=template&id=45698bb0&"
import script from "./CameraPageShootCardAutoDriversLicenseDiagonal1.vue?vue&type=script&lang=ts&"
export * from "./CameraPageShootCardAutoDriversLicenseDiagonal1.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports